import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    state_preview: true,
    colorPool: [],
  },
  mutations: {
    pushColorPool(state, val) {
      state.colorPool.push(val);
    },
    replaceColorPool(state, oldVal, newVal) {
      let idx = state.colorPool.indexOf(oldVal);
      if (idx == -1) return;
      state.colorPool[idx] = newVal;
    },
    initColorPool(state, val) {
      state.colorPool = val || [];
    },
    change_state_preview(state, val) {
      state.state_preview = val;
    },
  },
  actions: {
    pushColorPool(context, val) {
      context.commit('pushColorPool', val);
    },
    replaceColorPool(context, oldVal, newVal) {
      context.commit('replaceColorPool', oldVal, newVal);
    },
    initColorPool(context, val) {
      context.commit('initColorPool', val);
    },
    change_state_preview(context, val) {
      context.commit('change_state_preview', val);
    },
  },
});


// WEBPACK FOOTER //
// ./src/store/index.js